import React, { Component } from "react";
import { NavLink as RRNavLink } from "react-router-dom";
import styled from "styled-components";
import { getCountMsg } from "./../../Constants/Services";
import { NavItem, Navbar, Nav, NavLink, Row, Col, Container } from "reactstrap";
import StoreContext from './../../../Store/Context';
import {
  LOGO_SCHOOL,
  LOGOUT_ICON,
  MESSAGE_ICON,
  AGENDA_ICON,
  NOTAS_ICON,
  HORARIO_ICON,
  HOME_ICON,
  PAYMENT_ICON
} from "../../Constants/SrcImages";
import { push as Menu } from "react-burger-menu";
import "./../../../www/css/Menu.css";
const Logo = styled.img`
  height: 100px;
  width: 100px;
`;

var styles = {
  bmBurgerButton: {
    position: "fixed",
    width: "36px",
    height: "30px",
    left: "26px",
    top: "16px",
  },
  bmBurgerBars: {
    background: "#373a47",
  },
  bmBurgerBarsHover: {
    background: "#a90000",
  },
  bmCrossButton: {
    height: "24px",
    width: "24px",
  },
  bmCross: {
    background: "#bdc3c7",
  },
  bmMenuWrap: {
    position: "fixed",
    height: "100%",
  },
  bmMenu: {
    background: "#373a47",
    padding: "2.5em 1.5em 0",
    fontSize: "1.15em",
  },
  bmMorphShape: {
    fill: "#373a47",
  },
  bmItemList: {
    color: "#b8b7ad",
    padding: "0.8em",
  },
  bmItem: {
    display: "inline-block",
  },
  bmOverlay: {
    background: "rgba(0, 0, 0, 0.3)",
  },
};

interface ILayoutState {
  menuOpen: boolean;
  children: any;
  count:string;
}

interface ILayoutProps {
  children: any;
}
class LayoutTeachers extends Component<ILayoutProps, ILayoutState> {
  static contextType = StoreContext
  constructor(props: ILayoutProps) {
    super(props);
    this.state = {
      menuOpen: false,
      children: props.children,
      count:""
    };
  }

  handleStateChange(state: any) {
    this.setState({ menuOpen: state.isOpen });
  }

  closeMenu() {
    this.setState({ menuOpen: false });
  }

  toggleMenu() {
    this.setState((prevState) => ({
      menuOpen: !prevState.menuOpen,
    }));
  }

  updateTokens = () => {
    const test = this.context
    test.quitToken()
  };

  async fetchCount() {
    if(this.context.usr_type !== null){
      if (this.context.usr_type.replace(/\//g, "") === "teachers") {
        const response = await getCountMsg(this.context.per_id);
        if(response.gr[0].count!=="0" || response.teach[0].count!=="0"){
          this.setState({ count: "1"});
          setTimeout(() => {
           this.fetchCount()
          }, 15000);
        } 
        else{
          this.setState({ count: "0"});
          setTimeout(() => {
            this.fetchCount()
           }, 15000);
        }
    }
    }
  }


  componentDidMount() {
      this.fetchCount();
  }

  render() {
    const props = this.state;
    return (
      <React.Fragment>
        {window.screen.width < 576 && (
          <div className="d-block d-sm-none">
            {/* MOBILE */}
            <Menu id="menu-mb" styles={styles} width={180} isOpen={this.state.menuOpen} onStateChange={(state) => this.handleStateChange(state)}>
              <img className="logo-mobile m-auto" src={LOGO_SCHOOL} alt="" />
              <NavItem className="text-center w-100 mt-5 d-flex">
                <img src={HOME_ICON} alt="" />
                <NavLink tag={RRNavLink} to="/teachers/home" onClick={() => this.closeMenu()}>
                  Inicio
                </NavLink>
              </NavItem>
              <NavItem className="text-center w-100 d-flex">
                <img src={PAYMENT_ICON} alt="" />
                <NavLink tag={RRNavLink} to="/teachers/consejeria" onClick={() => this.closeMenu()}>
                  Consejeria
                </NavLink>
              </NavItem>
              <NavItem className="text-center w-100 d-flex">
                <img src={AGENDA_ICON} alt="" />
                <NavLink tag={RRNavLink} to="/teachers/agenda" onClick={() => this.closeMenu()}>
                  Agenda
                </NavLink>
              </NavItem>
              <NavItem className="text-center w-100 d-flex">
                <img src={NOTAS_ICON} alt="" />
                <NavLink tag={RRNavLink} to="/teachers/notebook" onClick={() => this.closeMenu()}>
                  Libreta
                </NavLink>
              </NavItem>
              <NavItem className="text-center w-100 d-flex">
                <img src={MESSAGE_ICON} alt="" />
                <NavLink tag={RRNavLink} to="/teachers/messages" onClick={() => this.closeMenu()}>
                  Mensajes             
                  {props.count !=="0"? <img src={MESSAGE_ICON} alt="" className="img-position"/>:null
                  }
                </NavLink>
              </NavItem>
              <NavItem className="text-center w-100 d-flex">
                <img src={HORARIO_ICON} alt="" />
                <NavLink tag={RRNavLink} to="/teachers/calendar" onClick={() => this.closeMenu()}>
                  Horario
                </NavLink>
              </NavItem>
              <NavItem className="text-center w-100 d-flex" onClick={()=> this.updateTokens()}>
                <img src={LOGOUT_ICON} alt="" />
                <NavLink tag={RRNavLink} to="/teachers/profile">
                  Salir
                </NavLink>
              </NavItem>
            </Menu>
            <Container className="font-size-14">
              <Row >
                <Col sm={12} className="container-mobile">
                  {this.props.children}
                </Col>
              </Row>
            </Container>
          </div>
        )}

        {window.screen.width > 576 && (
          <div className="d-none d-sm-block">
            <Container fluid={true} className="font-size-14">
              <Row>
                <Col sm={2}>
                  <Row>
                    <Navbar>
                      <Nav tabs>
                        <NavItem className="text-center w-100">
                          <NavLink>
                            <Logo src={LOGO_SCHOOL} className="m-auto" alt="" />
                          </NavLink>
                        </NavItem>
                        <NavItem className="text-center w-100">
                          <NavLink tag={RRNavLink} to="/teachers/home" activeClassName="active">
                            Inicio
                          </NavLink>
                        </NavItem>
                        <NavItem className="text-center w-100">
                          <NavLink tag={RRNavLink} to="/teachers/consejeria" activeClassName="active">
                            Consejeria
                          </NavLink>
                        </NavItem>
                        <NavItem className="text-center w-100">
                          <NavLink tag={RRNavLink} to="/teachers/agenda" activeClassName="active">
                            Agenda
                          </NavLink>
                        </NavItem>
                        <NavItem className="text-center w-100">
                          <NavLink tag={RRNavLink} to="/teachers/notebook" activeClassName="active">
                          Libreta de calificaciones
                          </NavLink>
                        </NavItem>
                        <NavItem className="text-center w-100">
                          <NavLink tag={RRNavLink} to="/teachers/messages" activeClassName="active">
                            Mensajes
                            {props.count !=="0"? <img src={MESSAGE_ICON} alt="" className="img-position"/>:null
                  }
                          </NavLink>
                        </NavItem>
                        <NavItem className="text-center w-100">
                          <NavLink tag={RRNavLink} to="/teachers/calendar" activeClassName="active">
                            Horario
                          </NavLink>
                        </NavItem>
                        <NavItem className="text-center w-100" onClick={()=> this.updateTokens()}>
                          <NavLink tag={RRNavLink} to="/teachers/profile">
                            Salir
                          </NavLink>
                        </NavItem>
                      </Nav>
                    </Navbar>
                  </Row>
                </Col>
                <Col className="mt-50px" sm={10}>
                  {this.props.children}
                </Col>
              </Row>
            </Container>
          </div>
        )}
      </React.Fragment>
    );
  }
}

export default LayoutTeachers;
